export interface AffiliateLink {
  retailer: string;
  url: string;
  logo?: string;
}

export interface GPUAffiliateLinks {
  gpuId: string;
  links: AffiliateLink[];
}

// Mock affiliate links - in production, these would be real affiliate URLs
export const gpuAffiliateLinks: Record<string, AffiliateLink[]> = {
  'rtx-5090': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+5090' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+5090' },
    { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+5090' },
    { retailer: 'B&H Photo', url: 'https://bhphotovideo.com/c/search?q=rtx+5090' },
  ],
  'rtx-4090': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4090' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4090' },
    { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4090' },
    { retailer: 'B&H Photo', url: 'https://bhphotovideo.com/c/search?q=rtx+4090' },
  ],
  'rtx-5080': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+5080' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+5080' },
    { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+5080' },
  ],
  'rtx-4080-super': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4080+super' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4080+super' },
    { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4080+super' },
  ],
  'rtx-5070-ti': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+5070+ti' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+5070+ti' },
    { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+5070+ti' },
  ],
  'rtx-5070': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+5070' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+5070' },
    { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+5070' },
  ],
  'rx-7900-xtx': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+7900+xtx' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+7900+xtx' },
    { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rx+7900+xtx' },
  ],
  'rx-9070-xt': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+9070+xt' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+9070+xt' },
  ],
  'rx-9070': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+9070' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+9070' },
  ],
  'rx-7800-xt': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+7800+xt' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+7800+xt' },
    { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rx+7800+xt' },
  ],
  'arc-b580': [
    { retailer: 'Amazon', url: 'https://amazon.com/s?k=intel+arc+b580' },
    { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=intel+arc+b580' },
    { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=intel+arc+b580' },
  ],
};

export function getAffiliateLinks(gpuId: string): AffiliateLink[] {
  return gpuAffiliateLinks[gpuId] || [
    { retailer: 'Amazon', url: `https://amazon.com/s?k=${gpuId.replace(/-/g, '+')}` },
    { retailer: 'Newegg', url: `https://newegg.com/p/pl?d=${gpuId.replace(/-/g, '+')}` },
  ];
}
